import { render, staticRenderFns } from "./addExamineProject.vue?vue&type=template&id=ebd54f74"
import script from "./addExamineProject.vue?vue&type=script&lang=js"
export * from "./addExamineProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports